import { Subject } from '@state-containers/core';
import type { TimeBlock } from '../types';

interface TimeBlockStateInterface {
  timeBlocks: TimeBlock[];
}

export const TimeBlockState = () => {
  const state = new Subject<TimeBlockStateInterface>({
    timeBlocks: [],
  });

  const actions = {
    create: (block: TimeBlock) => {
      state.value = {
        ...state.value,
        timeBlocks: [...state.value.timeBlocks, block],
      };
    },
    update: (updatedBlock: TimeBlock) => {
      state.value = {
        ...state.value,
        timeBlocks: state.value.timeBlocks.map((block) =>
          block.id === updatedBlock.id ? updatedBlock : block,
        ),
      };
    },
    delete: (id: string) => {
      state.value = {
        ...state.value,
        timeBlocks: state.value.timeBlocks.filter((block) => block.id !== id),
      };
    },
  };

  return { state, actions };
};
